import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import * as FileSaver from 'file-saver';

@Injectable({
  providedIn: 'root'
})
export class ExcelserviceService {

  constructor(private datePipe: DatePipe) { }

  fnExportSampleTemplate(reqdata: any) {
    const title = reqdata.title || 'Template';
    let header = reqdata.columnDefs.map(col => col.headerName);

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet('Sheet 1');

    let headerRow = worksheet.addRow(header);

    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD3D3D3' } 
      };
      cell.font = { bold: true, name: 'Arial', size: 10 };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    worksheet.columns.forEach(column => {
      column.width = 20;
    });

    workbook.xlsx.writeBuffer().then((buffer) => {
      let blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, title + '.xlsx');
    });
  }


  generateExcel(reqdata) {
    const title = reqdata.title;
    var header = [];
    for (var abo of reqdata.columnDefs) {
      header.push(abo.headerName);
    }
    
    var data = [];
    for (var pbo of reqdata.data) {
      var _s = [];
      for (var abo of reqdata.columnDefs) {
        _s.push(pbo[abo.field]);
      }
      data.push(_s);
    }

    let workbook = new Workbook();
    let worksheet = workbook.addWorksheet(title);

    let titleRow = worksheet.addRow([title]);
    titleRow.font = { name: 'Open Sans', size: 16, bold: true };
    titleRow.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFFFFF00' },
      bgColor: { argb: 'FF00B0F0' }
    };
    
    worksheet.addRow([]); 

    if (reqdata.filter && reqdata.filter.length > 0) {
      worksheet.addRow(reqdata.filter);
    }

    worksheet.mergeCells('A1:P2');
    worksheet.addRow([]);

    let headerRow = worksheet.addRow(header);
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF00B0F0' }
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    worksheet.addRows(data);

    worksheet.getColumn(3).width = 30;
    worksheet.getColumn(4).width = 30;
    worksheet.addRow([]);

    let footerRow = worksheet.addRow(['Powered By YesBoz Admin']);
    footerRow.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFCCFFE5' }
    };
    footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    workbook.xlsx.writeBuffer().then((buffer) => {
      let blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, title + '.xlsx'); 
    });
  }
}